<script setup lang="ts">
import type { PortableTextBlock } from '@sanity/types';
import { computed, type Component } from 'vue';
import type { FAQ } from '@pkg/sanity-utils/types/faq';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    items: FAQ['items'];
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  items: props.block?.items,
}));

</script>

<template>
  <div class="wrapper wrapper--content">
    <component :is="props.config?.innerComponent" v-bind="data"/>
  </div>
</template>
